import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { logoutSuccess } from '@store/reducers/auth/loginSlice';
import { signOut } from 'aws-amplify/auth';
import Dashboard from '@components/Layout/DashboardLayout';
import { getDataUsingUserId, updateUser } from '@utils/sharedUtils';
import { useAppSelector } from '@store/hooks';
import { formattedDateTime } from '@utils/utils';
interface MainContentProps {
    listType: string;
}

const Home = ({ listType }: MainContentProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let userId = useAppSelector((state) => state.login.loggedInUserID);

    const handleSignOut = async () => {
        try {
            const userData = await getDataUsingUserId('user_info', userId);

            if (userData && userData.Items && userData.Items.length > 0) {
                const tableUuid = userData.Items[0].uuid.S;

                if(tableUuid) {
                    let attributeNames = {
                        '#fcm_token': 'fcm_token',
                        '#modified_by': 'modified_by',
                        '#modified_at': 'modified_at'
                    };
                
                    let attributeValues = {
                        ':fcm_token': { M: {} },
                        ':modified_by': { S: userId },
                        ':modified_at': { S: formattedDateTime },
                    };
                
                    let updateExpression =
                        'SET #fcm_token = :fcm_token, #modified_by = :modified_by, #modified_at = :modified_at';
                        
                    await updateUser('user_info', tableUuid, attributeNames, attributeValues, updateExpression);
                }
            }

            await signOut();
            dispatch(logoutSuccess());
        } catch (error) {
            console.log('error signing out: ', error);
        }
    };
    return (
        <>
            <Dashboard listType={listType} />
            {/* <p>You can put the components of your app here</p>
            <h1>{t('greeting')}</h1>

            <button
                className="text-white bg-primary mt-3 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                onClick={handleSignOut}
            >
                {t('auth.signout')}
            </button> */}
        </>
    );
};

export default Home;
